console.log("custom search active");

const HIDDEN_TYPE = "wholesale";
const cache = {};

function getHandle(url) {
  try {
    const u = new URL(url, window.location.origin);
    const parts = u.pathname.split("/").filter(Boolean);
    const i = parts.indexOf("products");
    return i !== -1 ? parts[i + 1] : null;
  } catch {
    return null;
  }
}

async function isWholesale(handle) {
  if (!handle) return false;

  if (cache[handle] !== undefined) {
    return cache[handle];
  }

  try {
    const res = await fetch(`/products/${handle}.js`);
    const data = await res.json();

    const result =
      (data.product_type || "").toLowerCase().trim() === HIDDEN_TYPE;

    cache[handle] = result;
    return result;
  } catch {
    cache[handle] = false;
    return false;
  }
}

async function filterResults() {
  const container = document.querySelector("[data-live-search-results]");
  if (!container) return;

  const items = container.querySelectorAll(".search-flydown--product");

  for (const item of items) {
    if (item.dataset.checked) continue; // prevent loops
    item.dataset.checked = "true";

    const link = item.getAttribute("href")
      ? item
      : item.querySelector("a");

    if (!link) continue;

    const href = link.getAttribute("href");
    if (!href || !href.includes("/products/")) continue;

    const handle = getHandle(href);
    const hide = await isWholesale(handle);

    if (hide) {
      item.remove();
    }
  }
}

function runFilterRepeatedly() {
  let count = 0;

  const interval = setInterval(() => {
    filterResults();
    count++;

    // stop after ~2 seconds
    if (count > 10) {
      clearInterval(interval);
    }
  }, 200);
}

const observer = new MutationObserver(() => {
  runFilterRepeatedly();
});

function init() {
  const target = document.querySelector("[data-live-search-results]");
  if (!target) return;

  observer.observe(target, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", init);